import { useEffect, useState } from "react";
import { useQuery } from "react-query";

import Button from "components/Buttons/Button/Button";
import DataTable from "components/DataTable/DataTable";
import TableScrollHint from "components/Table/TableScrollHint";
import LoadingWrapper from "../../../components/Loading/LoadingWrapper";
import useAPI from "../../../hooks/useAPI";
import ProfilePage from "../ProfilePage";
import tblFields from "./tblFields.json";
import { useTranslation } from "react-i18next";
import Empty from "components/Empty/Empty";
import scss from "./AddressesPage.module.scss";

const AddressesPage = () => {
    const { t } = useTranslation();

    const api = useAPI();
    const apiPath = "profile/company/shipping-address";

    // Load all notifications
    const { data, isLoading, refetch: refetchList } = useQuery([], () => api.list(apiPath));
    // Local state for the addresses
    const [addresses, setAddresses] = useState();

    const { data: config } = useQuery(["companyDeliveryAdressesConfig"], () => api.get("/options/profile-page/company-delivery-addresses/config"));

    useEffect(() => {
        setAddresses(data?.items);
    }, [data, setAddresses]);

    let updatedTblFields = tblFields;

    if (config?.user_can_edit_company_address_data === "1") {
        updatedTblFields = [...updatedTblFields, { field: "action", label: "", type: "edit", showOnMobile: true }];
    }

    if (config?.user_can_delete_company_address_data === "1") {
        if (config?.user_can_edit_company_address_data === "1") {
            updatedTblFields = updatedTblFields.map((field) => {
                if (field.type === "edit") return { field: "action", label: "", type: "edit_delete", refetch: refetchList, showOnMobile: true };
                return field;
            });
        } else updatedTblFields = [...updatedTblFields, { field: "action", label: "", type: "delete", showOnMobile: true }];
    }

    return (
        <ProfilePage>
            <div className={scss.heading}>
                <h4>{t("address_profile-default-title")}</h4>
                {config?.active === "1" && config.user_can_add_company_address_data === "1" && (
                    <Button className={scss.newButton} label={t("global-default-text-New")} to="new" icon={<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>} />
                )}
            </div>

            {config && config?.active !== "1" && <Empty message={t("global-module_locked-title")} />}
            {data && config?.active === "1" && (
                <LoadingWrapper isLoading={isLoading}>
                    {addresses?.length > 0 ? (
                        <>
                            <TableScrollHint />
                            <div className={scss.table}><DataTable translateKey={"address_profile-default"} columns={updatedTblFields} data={addresses} apiUrl={apiPath} /></div>
                        </>
                    ) : (
                        <div className={scss.emptyState}>
                            <span className={scss.emptyIcon} aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z" /><circle cx="12" cy="10" r="2.5" /></svg></span>
                            <p>{t("address_profile-default-text-no_addresses")}</p>
                            {config.user_can_add_company_address_data === "1" && <span>Dodajte adresu za dostavu poručenih artikala.</span>}
                        </div>
                    )}
                </LoadingWrapper>
            )}
        </ProfilePage>
    );
};

export default AddressesPage;
